import { CSSProperties } from 'react';
import { Row, Typography } from '@tempmee/react';

interface ILabelValueDisplayProps {
  label: string;
  value?: string | null;
  labelStyle?: CSSProperties;
  valueStyle?: CSSProperties;
  containerStyle?: CSSProperties;
}

export const LabelValueDisplay = ({
  label,
  value = '',
  labelStyle,
  valueStyle,
  containerStyle,
}: ILabelValueDisplayProps) => {
  return (
    <Row align="start" gap={4} className="flex-1" style={containerStyle}>
      <Typography
        as="span"
        size="body_large"
        bold
        style={{
          wordBreak: 'break-word',
          flex: 0.4,
          ...labelStyle,
        }}
      >
        {label}
      </Typography>
      <Typography as="span" style={{ flex: 1, wordBreak: 'break-word', ...valueStyle }}>
        {value}
      </Typography>
    </Row>
  );
};
